// extracted by mini-css-extract-plugin
module.exports = {"SizeModule":"SizeModule_SizeModule__azVx7","ImageContainer":"SizeModule_ImageContainer__3dBjt"};